import { ErrorHandler, Injectable, Injector, NgZone, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RgsObjectService } from 'src/app/services/object/rgs-object.service';

@Injectable()
export class ErrorHandlerService implements ErrorHandler {
  private readonly injector = inject(Injector);

  private router!: Router;
  private rgsObjectService!: RgsObjectService;
  private ngZone!: NgZone;

  constructor() {
    const injector = this.injector;

    setTimeout(() => {
      this.router = injector.get(Router);
      this.rgsObjectService = injector.get(RgsObjectService);
      this.ngZone = injector.get(NgZone);
    });
  }

  public handleError(error: unknown): void {
    if (error instanceof Error) {
      if (
        error.message.includes('HttpErrorResponse') &&
        error.message.includes('"status":404') &&
        error.message.includes('/inspection/')
      ) {
        console.info('404 HttpErrorResponse in inspections: redirecting to inspection list');

        this.ngZone.run(() => {
          if (this.rgsObjectService.selectedValue) {
            this.router.navigate([`/objects/object/${this.rgsObjectService.selectedValue.id}/inspections`]);
          }
        });
      } else {
        throw error;
      }
    } else {
      let message = 'An error occurred';

      if (typeof error === 'string') {
        message = error;
      }

      throw new Error(message);
    }
  }
}
